import { serverTimestamp } from "firebase/firestore";
// import { format, toISODate } from "../../utils/date"; // Mantemos as Utils prontas pro front, pro caso de format no Runtime

/**
 * Converter Firestore para AccountingRecords
 */
export const accountingRecordConverter = {
    toFirestore: (data) => {
        const doc = { ...data };
        
        doc.updatedAt = serverTimestamp();
        if (!doc.createdAt) {
            doc.createdAt = serverTimestamp();
        }
        
        return doc;
    },
    
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options);
        return {
            id: snapshot.id,
            ...data,
            // As datas createdAt / updatedAt transformamos em iso string no model de runtime
            createdAt: data.createdAt?.toDate ? data.createdAt.toDate().toISOString() : null,
            updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate().toISOString() : null,
        };
    }
};
